// extracted by mini-css-extract-plugin
module.exports = {"header":"header--GgnR4sMfChIoHjf8_6Vi side-bar-section__title"};